<!-- Quick View Panel Code  -->
<p-drawer styleClass="p-sidebar p-sidebar-lg ui-sidebar-lg" (onHide)="onHideSideBar()"
  [style]="{'width':'auto','max-width': '900px','height':'auto','overflow-y': 'auto','max-height':'100%'}"
  [(visible)]="display" position="right">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-col-12">
      @for (dataset of selectedRow; track dataset + '-'+ $index){
      <span>
        @for(col of quickviewcols; track col.ui_columnname + '-'+ $index){
        <span>
          @if(col?.disabled != 'true'){
          @if(col?.datatype == 'json'){
          <div class="ui-grid-col-12">
            <div class="ui-grid-col-2 quick-view-grid-row-hg">
              <label for="ui_columnName">{{col.ui_columnname}}</label>
            </div>
            <div class="ui-grid-col-10 quick-view-grid-row">
              <pre [innerHTML]="(dataset[col.mappingkey]) | prettyjson: [false, 3]"></pre>
            </div>
          </div>
          }@else{
          <div class="ui-grid-col-6">
            <div class="ui-grid-col-4 quick-view-grid-row-hg">
              <label for="ui_columnName">{{col.ui_columnname}}</label>
            </div>
            @if(col?.datatype != 'json'){
                        @if((col.datatype | lowercase) =='boolean'){
                        <span>
                          <div class="ui-grid-col-7 quick-view-grid-row">
                              <input [disabled]="true" pInputText [value]="dataset[col.mappingkey] == 1 ? 'true' : 'false'" />
                          </div>
                        </span>
                        }@else{
                          <span>
                            <div class="ui-grid-col-7 quick-view-grid-row">
                              <input [disabled]="true" pInputText [(ngModel)]="dataset[col.mappingkey]" />
                            </div>
                          </span>
                        }
            }
          </div>
          }
          }
        </span>
        }
      </span>
      }
    </div>
  </div>
</p-drawer>